import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Link,
  useDisclosure
} from '@chakra-ui/react'
import { useEffect, useRef } from 'react'
import ABOUT from '../../constants/about'

const PortfolioDialog = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = useRef()

  useEffect(() => {
    const timer = setTimeout(() => {
      onOpen()
    }, 30000)

    // Cleanup the timer on unmount
    return () => clearTimeout(timer)
  }, [onOpen])

  return (
    <AlertDialog motionPreset="slideInBottom" leastDestructiveRef={cancelRef} onClose={onClose} isOpen={isOpen} isCentered>
      <AlertDialogOverlay />

      <AlertDialogContent m={4}>
        <AlertDialogHeader data-testid="dialog-header">
          Hallo,
          <br />I Appreciate Your Visit!
        </AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>
          I'm so glad you stopped by! If you'd like to see my updated portfolio (all projects and work samples), just click the button below. I'd love
          to show you what I've been working on!
        </AlertDialogBody>
        <AlertDialogFooter>
          <Link href={ABOUT.pdf_projects} isExternal>
            <Button bgColor={'green.600'} ml={3} color={'white'}>
              Check It Out!
            </Button>
          </Link>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default PortfolioDialog
